export const MAX_PASSWORD_LENGTH = 150
export const MIN_PASSWORD_LENGTH = 8
export const MAX_PHONE_NUMBER_LENGTH = 14
export const MIN_PHONE_NUMBER_LENGTH = 10
